package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.PathFillType.Companion.EvenOdd
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.FlagBa: ImageVector
    get() {
        if (_flagBa != null) {
            return _flagBa!!
        }
        _flagBa = Builder(name = "FlagBa", defaultWidth = 512.0.dp, defaultHeight = 512.0.dp,
                viewportWidth = 512.0f, viewportHeight = 512.0f).apply {
            group {
            }
            group {
                path(fill = SolidColor(Color(0xFF000099)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = EvenOdd) {
                    moveTo(0.0f, 0.0f)
                    lineTo(512.0f, 0.0f)
                    lineTo(512.0f, 512.0f)
                    lineTo(0.0f, 512.0f)
                    lineTo(0.0f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFCC00)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = EvenOdd) {
                    moveTo(77.0f, 0.0f)
                    lineTo(514.0f, 437.0f)
                    lineTo(514.0f, 0.0f)
                    lineTo(77.0f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFFFFF)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = EvenOdd) {
                    moveTo(461.4f, 470.4f)
                    lineTo(435.3f, 451.3f)
                    lineTo(408.4f, 470.3f)
                    lineTo(418.6f, 439.1f)
                    lineTo(392.2f, 419.9f)
                    lineTo(424.9f, 419.9f)
                    lineTo(435.1f, 388.9f)
                    lineTo(445.1f, 420.0f)
                    lineTo(477.9f, 420.1f)
                    lineTo(451.7f, 439.5f)
                    lineTo(461.4f, 470.4f)
                    close()
                    moveTo(538.1f, 480.8f)
                    lineTo(505.4f, 480.8f)
                    lineTo(495.4f, 449.6f)
                    lineTo(485.2f, 480.7f)
                    lineTo(452.4f, 480.7f)
                    lineTo(478.8f, 499.9f)
                    lineTo(468.7f, 531.1f)
                    lineTo(495.5f, 512.1f)
                    lineTo(521.7f, 531.1f)
                    lineTo(511.9f, 500.2f)
                    lineTo(538.1f, 480.8f)
                    close()
                    moveTo(391.8f, 379.6f)
                    lineTo(418.0f, 360.2f)
                    lineTo(385.3f, 360.2f)
                    lineTo(375.2f, 329.0f)
                    lineTo(365.0f, 360.0f)
                    lineTo(332.3f, 360.0f)
                    lineTo(358.7f, 379.3f)
                    lineTo(348.6f, 410.4f)
                    lineTo(375.4f, 391.4f)
                    lineTo(401.5f, 410.5f)
                    lineTo(391.8f, 379.6f)
                    close()
                    moveTo(331.5f, 319.2f)
                    lineTo(357.7f, 299.8f)
                    lineTo(324.9f, 299.7f)
                    lineTo(314.9f, 268.5f)
                    lineTo(304.7f, 299.7f)
                    lineTo(272.0f, 299.6f)
                    lineTo(298.4f, 318.8f)
                    lineTo(288.2f, 350.0f)
                    lineTo(315.1f, 331.0f)
                    lineTo(341.2f, 350.1f)
                    lineTo(331.5f, 319.2f)
                    close()
                    moveTo(271.8f, 259.5f)
                    lineTo(298.0f, 240.1f)
                    lineTo(265.3f, 240.1f)
                    lineTo(255.2f, 208.9f)
                    lineTo(245.0f, 240.0f)
                    lineTo(212.3f, 240.0f)
                    lineTo(238.7f, 259.2f)
                    lineTo(228.6f, 290.4f)
                    lineTo(255.4f, 271.4f)
                    lineTo(281.5f, 290.4f)
                    lineTo(271.8f, 259.5f)
                    close()
                    moveTo(211.4f, 199.2f)
                    lineTo(237.6f, 179.9f)
                    lineTo(204.8f, 179.8f)
                    lineTo(194.8f, 148.6f)
                    lineTo(184.6f, 179.8f)
                    lineTo(151.9f, 179.7f)
                    lineTo(178.3f, 198.9f)
                    lineTo(168.1f, 230.1f)
                    lineTo(195.0f, 211.1f)
                    lineTo(221.1f, 230.1f)
                    lineTo(211.4f, 199.3f)
                    lineTo(211.4f, 199.2f)
                    close()
                    moveTo(151.7f, 139.3f)
                    lineTo(178.0f, 120.0f)
                    lineTo(145.3f, 119.9f)
                    lineTo(135.3f, 88.7f)
                    lineTo(125.0f, 119.8f)
                    lineTo(92.2f, 119.8f)
                    lineTo(118.6f, 139.0f)
                    lineTo(108.5f, 170.2f)
                    lineTo(135.3f, 151.2f)
                    lineTo(161.4f, 170.2f)
                    lineTo(151.7f, 139.3f)
                    close()
                    moveTo(91.7f, 79.3f)
                    lineTo(118.0f, 60.0f)
                    lineTo(85.3f, 59.9f)
                    lineTo(75.3f, 28.7f)
                    lineTo(65.0f, 59.8f)
                    lineTo(32.2f, 59.8f)
                    lineTo(58.6f, 79.0f)
                    lineTo(48.5f, 110.2f)
                    lineTo(75.3f, 91.2f)
                    lineTo(101.5f, 110.2f)
                    lineTo(91.7f, 79.3f)
                    close()
                    moveTo(31.7f, 19.3f)
                    lineTo(58.0f, 0.0f)
                    lineTo(25.2f, -0.1f)
                    lineTo(15.2f, -31.3f)
                    lineTo(4.8f, -0.2f)
                    lineTo(-27.9f, -0.2f)
                    lineTo(-1.4f, 19.0f)
                    lineTo(-11.5f, 50.2f)
                    lineTo(15.3f, 31.2f)
                    lineTo(41.4f, 50.2f)
                    lineTo(31.7f, 19.3f)
                    close()
                }
            }
        }
        .build()
        return _flagBa!!
    }

private var _flagBa: ImageVector? = null
